import { Button, message } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".csv";

const ExportCSV = ({ dataSet, fileName, loading = false }) => {
  const [submitted, setSubmitted] = useState(false);
  const [dateSource, setDataSource] = useState([]);

  async function handleClick() {
    setSubmitted(true);
    try {
      const ws = XLSX.utils.json_to_sheet(dateSource);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      message.error("Action has error", 20);
      console.log(error);
    } finally {
      setSubmitted(false);
    }
  }

  useEffect(() => {
    setDataSource(dataSet);
  }, [dataSet]);

  return (
    <Button
      type="primary"
      htmlType="button"
      disabled={submitted || loading}
      className=""
      onClick={handleClick}
    >
      Export CSV
    </Button>
  );
};

export default ExportCSV;
